export const getErrorMessage = (error: any): string => {
  const raw = error?.response?.data?.error || error?.data?.error || error?.message || ''

  const technicalPatterns = [
    /Sequelize/i,
    /SQL/i,
    /ECONNREFUSED/i,
    /ECONNRESET/i,
    /timeout/i,
    /undefined/i,
    /null/i,
    /TypeError/i,
    /Cannot read/i,
    /duplicate key/i,
    /validation error/i,
    /connection/i,
    /ETIMEDOUT/i,
    /ENOTFOUND/i,
  ]

  for (const pattern of technicalPatterns) {
    if (pattern.test(raw)) {
      return 'Не удалось создать заказ. Попробуйте позже.'
    }
  }

  // ⭐ Проверка что сообщение на русском (хотя бы 3 буквы)
  const russianCount = (raw.match(/[а-яА-Я]/g) || []).length
  const isRussian = russianCount >= 3
  const isTooLong = raw.length > 150

  if (isRussian && !isTooLong) {
    return raw
  }

  return 'Не удалось создать заказ. Свяжитесь с нами удобным способом.'
}
